<template lang="pug">
    .match-mini.columns.is-multiline.is-gapless(:class="{ 'is-active': isActive }")
        .column.is-12.match-header(:class="[timeLevelClass]")
            .columns.is-gapless.is-mobile
                .column.is-one-fifth-tablet
                    a.match-link(:href="matchURL" target="_blank")
                        span.icon.is-small
                            i.fas.fa-futbol.fa-lg
                    span.icon.is-small(v-if="match.hasSignal")
                        i.fas.fa-check-circle
                .column.columns.is-gapless
                    .column
                        .title.is-6.is-unselectable {{ match.league }}
                    .column.is-one-quarter-tablet
                        .match-time.is-flex.is-unselectable
                            .title.is-5(@click="$emit('view')") {{ match.time }}
        .column.is-12.match-body
            .columns.is-gapless
                .column.columns.is-gapless(:class="`team-level-${propByCategory(match.home.statistic.level)}`")
                    .column
                      span {{ match.home.team ? match.home.team.name : "Home team" }}({{ match.home.winCoef }})
                      span.penalty-card.yellow(v-if="match.home.statistic.yellowCards") {{ match.home.statistic.yellowCards }}
                      span.penalty-card.red(v-if="match.home.statistic.redCards") {{ match.home.statistic.redCards }}
                    .column.tag(v-for="stat in stats.home" :class="stat.$class") {{ stat.key }}: {{ stat.value }}
                .column.is-1.has-text-centered.has-text-weight-bold
                  span(:class="{'is-active': match.home.activeGoal}") {{ match.home.statistic.score }}
                  span -
                  span(:class="{'is-active': match.away.activeGoal}") {{ match.away.statistic.score }}
                .column.columns.is-gapless(:class="`team-level-${propByCategory(match.away.statistic.level)}`")
                    .column
                      span {{ match.away.team ? match.away.team.name : "Away team" }}({{ match.away.winCoef }})
                      span.penalty-card.yellow(v-if="match.away.statistic.yellowCards") {{ match.away.statistic.yellowCards }}
                      span.penalty-card.red(v-if="match.away.statistic.redCards") {{ match.away.statistic.redCards }}
                    .column.tag(v-for="stat in stats.away" :class="stat.$class") {{ stat.key }}: {{ stat.value }}
</template>

<script>
export default {
  name: "MatchMini",
  props: {
    match: Object,
    source: Object,
    active: Number
  },
  data: () => ({
    openStatistic: false,
    statistic: ["dAtk", "shots", "sOn", "sOff"]
  }),
  computed: {
    isActive() {
      return this.match._id === this.active;
    },
    filterCategory() {
      return this.$store.getters.filterCategory(this.$route);
    },
    matchURL() {
      return `${this.source.url}/detail/${this.match._id}.html`;
    },
    timeLevelClass() {
      const timeLevel = this.propByCategory(this.match.timeLevel);
      if (timeLevel === "0") return "";
      switch (timeLevel) {
        case 1:
          return "has-background-primary";
        case 2:
          return "has-background-warning";
        case 3:
          return "has-background-danger";
        default:
          return "";
      }
    },
    stats() {
      const levelData = this.$store.getters.statLevelData;
      const statClass = { 1: "success", 2: "warning", 3: "danger" };
      return ["home", "away"].reduce((obj, type) => {
        const stats = this.statistic.map(key => {
          const value = this.match[type].statistic[key];
          const $class = Object.keys(levelData[key]).reduce((c, k) => {
            if (k > 3) return c;
            const limit = levelData[key][k];
            return value >= limit ? `is-${statClass[k]}` : c;
          }, "");
          return { key, value, $class };
        });
        return { ...obj, [type]: stats };
      }, {});
    }
  },
  methods: {
    propByCategory(prop) {
      if (!prop || !prop.hasOwnProperty(this.filterCategory)) return "0";
      return prop[this.filterCategory];
    },
    objStat(type, value) {
      if (["dAtk", "sOn", "sOff", "shots"].includes(type)) {
        const levelData = this.$store.getters.statLevelData;
        if (!levelData) return res;
        const statClass = { 1: "success", 2: "warning", 3: "danger" };
        const $class = Object.keys(levelData[type]).reduce((c, k) => {
          if (k > 3) return c;
          const limit = levelData[type][k];
          return res >= limit ? `has-text-${statClass[k]}` : c;
        }, "");
        return $class
          ? `<span class="has-text-weight-bold ${$class}">${res}</span>`
          : res;
      }

      return res;
    },
    sm(obj) {
      let $class = "";
      if (obj.hasOwnProperty("level")) {
        switch (parseInt(obj.level)) {
          case 1:
            $class = "is-success";
            break;
          case 2:
            $class = "is-warning";
            break;
          case 3:
            $class = "is-danger";
            break;
        }
      } else if (obj.hasOwnProperty("time")) {
        const time = obj.time.split("~");
        switch (parseInt(time[0])) {
          case 1:
          case 16:
          case 31:
            $class = "is-success";
            break;
          case 61:
            $class = "is-warning";
            break;
          case 76:
            $class = "is-danger";
            break;
        }
      }
      return `<span class="tag ${$class}">${obj.time}</span>`;
    }
  }
};
</script>

<style lang="scss" scoped>
.match-mini {
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;

  &.is-active {
    .match-header {
      .match-link {
        animation: rotate 3s infinite;
      }
    }
  }

  .match-header {
    color: #000;
    background: #d7d7d7;
    transition: all 0.3s linear;

    & > .columns {
      & > .column {
        &:first-child {
          display: flex;
          align-items: center;
          padding-left: 0.3rem !important;

          @media screen and (max-width: $tablet) {
            flex: 0;
          }
        }

        &:last-child {
          align-items: center;
          @media screen and (max-width: $tablet) {
            flex: 1;

            .column {
              &:first-child {
                justify-content: flex-end !important;

                .title {
                  padding: 0 1rem;
                  font-size: 0.9rem;
                  line-height: 1.5rem !important;
                  font-weight: normal;
                }
              }

              &:last-child {
                .match-time {
                  .title {
                    font-size: 1.2rem;
                    padding-bottom: 0.2rem;
                    font-weight: bold;
                  }
                }
              }
            }
          }

          .column {
            display: flex;
            &:first-child {
              justify-content: center;

              .title {
                line-height: 2rem;
              }
            }

            &:last-child {
              justify-content: flex-end;
              position: relative;

              .match-time {
                cursor: pointer;
                padding: 0 0.7rem;
                .title {
                  opacity: 0.8;

                  &::after {
                    content: "'";
                    animation: blink 1s infinite;
                  }
                }
              }
            }
          }
        }
      }
    }

    .match-link,
    .title {
      color: #000;
    }

    .match-link {
      display: flex;
      padding: 0.3rem;
      border-radius: 50%;
      background-color: transparent;
      transition: all 0.2s linear;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }

  .match-body {
    color: #fff;
    background: #283238;
    transition: all 0.3s linear;

    & > .columns {
      .is-gapless:not(:last-child) {
        margin-bottom: 0;
      }

      & > .column {
        & > span.is-active {
          text-shadow: 1px -1px #ff3860, -1px 1px #ff3860, -1px 0px #ff3860,
            0 1px #ff3860, 1px 0 #ff3860, 0 -1px #ff3860;
        }
        &.team-level-1 {
          background: #00bb8a;
        }
        &.team-level-2 {
          background: #ffdd57;
          color: #000;
        }
        &.team-level-3 {
          background: #d33254;
        }
        & > .column {
          flex: 1;
          &:first-child {
            flex: 5;
            padding: 0 0.3rem !important;
          }
        }
      }
    }
  }

  .penalty-card {
    font-size: 1rem;
    border-radius: 3px;
    height: 1.3rem;
    width: 1.1rem;
    display: inline-block;
    text-align: center;
    color: $defaultColor;

    &.yellow {
      background-color: yellow;
      color: $cardFontColor;
    }
    &.red {
      background-color: red;
    }
  }
}

@keyframes blink {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
